async function readEntryAsFiles(entry: FileSystemEntry): Promise<File[]> {
  if (entry.isFile) {
    return new Promise<File[]>((resolve, reject) => {
      (entry as FileSystemFileEntry).file(
        (file) => resolve([file]),
        (err) => reject(err)
      );
    });
  }

  if (entry.isDirectory) {
    const reader = (entry as FileSystemDirectoryEntry).createReader();
    const allFiles: File[] = [];

    const readBatch = (): Promise<FileSystemEntry[]> =>
      new Promise((resolve, reject) => {
        reader.readEntries(resolve, reject);
      });

    let batch: FileSystemEntry[];
    do {
      batch = await readBatch();
      for (const childEntry of batch) {
        const childFiles = await readEntryAsFiles(childEntry);
        allFiles.push(...childFiles);
      }
    } while (batch.length > 0);

    return allFiles;
  }

  return [];
}

export async function extractFilesFromDataTransfer(dataTransfer: DataTransfer): Promise<File[]> {
  if (dataTransfer.items && dataTransfer.items.length > 0) {
    const entries: FileSystemEntry[] = [];
    for (let i = 0; i < dataTransfer.items.length; i++) {
      const item = dataTransfer.items[i];
      const entry = item.webkitGetAsEntry?.();
      if (entry) entries.push(entry);
    }
    if (entries.length > 0) {
      const fileArrays = await Promise.all(entries.map(readEntryAsFiles));
      return fileArrays.flat();
    }
  }
  return Array.from(dataTransfer.files);
}
